import React, { useState } from 'react';
// import { db, collection, addDoc, serverTimestamp } from '../firebase';
import { GOOGLE_SCRIPT_URL } from '../config';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    organization: '',
    participants: '',
    format: 'Onsite',
    requirement: ''
  });
  const [formStatus, setFormStatus] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);

  React.useEffect(() => {
    const selected = localStorage.getItem('selectedProgram');
    if (selected) {
      setFormData((prev) => ({
        ...prev,
        requirement: `Inquiry about program: ${selected}`
      }));
      localStorage.removeItem('selectedProgram');
    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const socialIconsRowStyle = {
    display: 'flex',
    justifyContent: 'center',
    gap: '18px',
    flexWrap: 'wrap',
    alignItems: 'center'
  };

  const socialIconStyle = {
    width: '60px',
    height: '60px',
    display: 'grid',
    placeItems: 'center',
    borderRadius: '999px',
    border: '1px solid rgba(15, 47, 33, 0.12)',
    background: '#fff',
    color: '#0e2118',
    textDecoration: 'none',
    transition: 'transform 0.2s ease, background 0.2s ease, color 0.2s ease'
  };

  const socialIconBrandStyles = {
    tiktok: { background: '#000', color: '#fff', border: '1px solid rgba(255,255,255,0.12)' },
    youtube: { background: '#FF0000', color: '#fff', border: '1px solid rgba(255,255,255,0.12)' },
    facebook: { background: '#1877F2', color: '#fff', border: '1px solid rgba(255,255,255,0.12)' },
    linkedin: { background: '#0A66C2', color: '#fff', border: '1px solid rgba(255,255,255,0.12)' },
    upwork: { background: '#6FDA44', color: '#fff', border: '1px solid rgba(255,255,255,0.12)' }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setFormStatus('Sending…');

    // Format the email message body with all inquiry details
    const messageBody = `
New Training Inquiry from Mr Excel Sri Lanka website:

• Name: ${formData.name}
• Email: ${formData.email}
• Phone: ${formData.phone}
• Organization: ${formData.organization || 'N/A'}
• Number of Participants: ${formData.participants || 'N/A'}
• Preferred Format: ${formData.format}
• Brief Training Requirement:
${formData.requirement}
    `;

    const templateParams = {
      name: formData.name,
      email: formData.email,
      title: 'New Training Inquiry',
      message: messageBody,
    };

    try {
      // 1. Send email via Google Apps Script (Free Gmail SMTP bridge)
      if (GOOGLE_SCRIPT_URL && GOOGLE_SCRIPT_URL !== "YOUR_GOOGLE_APPS_SCRIPT_WEB_APP_URL") {
        await fetch(GOOGLE_SCRIPT_URL, {
          method: 'POST',
          mode: 'no-cors',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(templateParams)
        });
      } else {
        console.warn("Google Apps Script URL is not configured. Please set GOOGLE_SCRIPT_URL in src/config.js");
      }

      // 2. Add document to the "inquiries" Firestore collection in background (does not block)
      /*
      addDoc(collection(db, 'inquiries'), {
        ...formData,
        createdAt: serverTimestamp()
      }).catch((dbError) => {
        console.warn("Firestore backup save failed:", dbError);
      });
      */

      setFormStatus('');
      setShowSuccess(true);
      setFormData({
        name: '',
        email: '',
        phone: '',
        organization: '',
        participants: '',
        format: 'Onsite',
        requirement: ''
      });
    } catch (error) {
      console.error("Failed to send inquiry via Google Apps Script:", error);
      setFormStatus('Failed to send inquiry. Please try again or contact info@mrexcelsrilanka.com.');
    }
  };

  return (
    <main>
      <section className="page-hero">
        <div className="container">
          <span className="eyebrow">Contact Mr Excel Sri Lanka</span>
          <h1>Tell me what your team needs to achieve.</h1>
          <p className="lead max-820">Share the participants, current Excel challenges and expected outcomes.</p>
        </div>
      </section>

      {/* Social Media Icons Section */}
      <section className="social-icons-section" style={{ paddingTop: '40px' }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <h2 style={{ fontSize: 'clamp(1.4rem, 2.5vw, 1.8rem)', marginTop: '8px', marginBottom: '28px', color: '#0e2118', fontWeight: 850 }}>Find Us On Social Media</h2>
          <div className="social-icons-row" style={socialIconsRowStyle}>
            <a href="https://www.tiktok.com/@mrexcel_sl" target="_blank" rel="noopener noreferrer" className="social-icon-btn social-icon-btn--tiktok" aria-label="TikTok" style={{ ...socialIconStyle, ...socialIconBrandStyles.tiktok }}>
              <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
                <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.17-2.86-.74-3.94-1.74-.22-.2-.43-.43-.63-.67-.07 2.62-.04 5.24-.04 7.86-.03 2.1-.64 4.28-2.14 5.75-1.8 1.85-4.57 2.45-7.05 1.79-2.73-.66-4.93-2.94-5.26-5.75-.48-3.32 1.48-6.73 4.67-7.66.97-.29 2.0-.36 3.0-.22v4.07c-.96-.21-2.01-.06-2.83.47-1.12.7-1.57 2.08-1.18 3.32.32 1.15 1.43 1.99 2.63 2.01 1.45.07 2.8-.84 3.19-2.22.12-.42.13-.86.13-1.3V.02z" />
              </svg>
            </a>
            <a href="https://youtube.com/@mrexcelsrilankayt?si=KjOEBtDEKjote56i" target="_blank" rel="noopener noreferrer" className="social-icon-btn social-icon-btn--youtube" aria-label="YouTube" style={{ ...socialIconStyle, ...socialIconBrandStyles.youtube }}>
              <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
                <path d="M23.498 6.163c-.272-1.022-1.074-1.826-2.099-2.099C19.55 3.5 12 3.5 12 3.5s-7.55 0-9.4.564c-1.025.273-1.827 1.077-2.099 2.099C0 8.015 0 12 0 12s0 3.985.502 5.837c.272 1.022 1.074 1.826 2.099 2.099 1.85.564 9.4.564 9.4.564s7.55 0 9.4-.564c1.025-.273 1.827-1.077 2.099-2.099.502-1.852.502-5.837.502-5.837s0-3.985-.502-5.837zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
              </svg>
            </a>
            <a href="https://www.facebook.com/mrexcelsrilanka/" target="_blank" rel="noopener noreferrer" className="social-icon-btn social-icon-btn--facebook" aria-label="Facebook" style={{ ...socialIconStyle, ...socialIconBrandStyles.facebook }}>
              <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
              </svg>
            </a>
            <a href="https://lk.linkedin.com/in/pramod-fernando-a28735372" target="_blank" rel="noopener noreferrer" className="social-icon-btn social-icon-btn--linkedin" aria-label="LinkedIn" style={{ ...socialIconStyle, ...socialIconBrandStyles.linkedin }}>
              <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
              </svg>
            </a>
            <a href="https://www.upwork.com/freelancers/pramodfernando" target="_blank" rel="noopener noreferrer" className="social-icon-btn social-icon-btn--upwork" aria-label="Upwork" style={{ ...socialIconStyle, ...socialIconBrandStyles.upwork }}>
              <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
                <path d="M17.47 6.07c-2.45 0-4.08 1.54-4.8 2.87-.53-1.07-1.12-2.58-1.54-4.07H8.38v6.78c0 1.7-.8 2.47-2.18 2.47s-2.17-.77-2.17-2.47V4.87H1.28v6.78c0 3.73 2.14 5.92 4.92 5.92s4.92-2.19 4.92-5.92V9.38c.36 1.15.88 2.5 1.48 3.59L10.82 20h2.96l1.39-3.79c.68.22 1.43.34 2.3.34 3.7 0 5.25-2.07 5.25-5.26 0-3.23-1.57-5.22-5.25-5.22zm0 7.82c-1.18 0-1.92-.35-2.5-.9l.75-2c.32-.47.88-.95 1.75-.95 1.62 0 2.22 1.18 2.22 2.92.01 1.74-.59 2.93-2.22 2.93z" />
              </svg>
            </a>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="section" id="inquiry">
        <div className="container split" style={{ alignItems: 'start' }}>
          <div>
            <span className="eyebrow">Direct contact</span>
            <h2>Let's discuss your requirement</h2>
            <div className="contact-list">
              <div className="contact-item">
                <strong>Email</strong>
                info@mrexcelsrilanka.com
              </div>
              <div className="contact-item">
                <strong>Phone / WhatsApp</strong>
                070 523 3369
              </div>
              <div className="contact-item">
                <strong>Training formats</strong>
                Onsite, online and hybrid
              </div>
            </div>
            <div className="pricing-note" style={{ marginTop: '22px' }}>
              For the best recommendation, include the team's departments, number of participants, current skill level and main reports or tasks.
            </div>
          </div>
          <div className="form-card">
            <form onSubmit={handleFormSubmit} noValidate>
              <div className="form-grid">
                <div className="form-group">
                  <label>Name</label>
                  <input 
                    name="name" 
                    required 
                    value={formData.name} 
                    onChange={handleInputChange} 
                  />
                </div>
                <div className="form-group">
                  <label>Email</label>
                  <input 
                    name="email" 
                    type="email" 
                    required 
                    value={formData.email} 
                    onChange={handleInputChange} 
                  />
                </div>
                <div className="form-group">
                  <label>Phone Number</label>
                  <input 
                    name="phone" 
                    type="tel" 
                    required 
                    value={formData.phone} 
                    onChange={handleInputChange} 
                  />
                </div>
                <div className="form-group">
                  <label>Organization Name</label>
                  <input 
                    name="organization" 
                    required 
                    value={formData.organization} 
                    onChange={handleInputChange} 
                  />
                </div>
                <div className="form-group">
                  <label>Number of Participants</label>
                  <input 
                    name="participants" 
                    type="number" 
                    min="1" 
                    value={formData.participants} 
                    onChange={handleInputChange} 
                  />
                </div>
                <div className="form-group">
                  <label>Preferred Format</label>
                  <select 
                    name="format" 
                    value={formData.format} 
                    onChange={handleInputChange}
                  >
                    <option value="Onsite">Onsite</option>
                    <option value="Online">Online</option>
                    <option value="Hybrid">Hybrid</option>
                    <option value="Not decided">Not decided</option>
                  </select>
                </div>
                <div className="form-group full">
                  <label>Brief Training Requirement</label>
                  <textarea 
                    name="requirement" 
                    required 
                    value={formData.requirement} 
                    onChange={handleInputChange}
                  ></textarea>
                </div>
                <div className="form-group full">
                  <button className="btn btn-primary" type="submit">
                    Send Training Inquiry
                  </button>
                  <p className="form-note">Your information will only be used to respond to this inquiry.</p>
                  {formStatus && (
                    <div className="form-status" aria-live="polite" style={{ marginTop: '12px', fontWeight: 'bold', color: '#0b8f55' }}>
                      {formStatus}
                    </div>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>

      {/* Modern Premium Success Modal Overlay */}
      {showSuccess && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(14, 33, 24, 0.55)',
          backdropFilter: 'blur(8px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
          animation: 'fadeIn 0.3s ease'
        }}>
          <div style={{
            background: '#fff',
            padding: '40px 32px',
            borderRadius: '24px',
            width: 'min(90%, 440px)',
            textAlign: 'center',
            boxShadow: '0 24px 60px rgba(0, 0, 0, 0.15)',
            border: '1px solid rgba(11, 143, 85, 0.15)',
            transform: 'scale(1)',
            transition: 'transform 0.3s ease'
          }}>
            <div style={{
              width: '80px',
              height: '80px',
              background: '#e9f6ef',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 24px',
              boxShadow: '0 8px 20px rgba(11, 143, 85, 0.15)',
              animation: 'pulseGreen 2s infinite'
            }}>
              <svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="#0b8f55" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </div>
            
            <h3 style={{ fontSize: '1.45rem', fontWeight: 850, color: '#0e2118', margin: '0 0 12px 0' }}>
              Inquiry Sent!
            </h3>
            <p style={{ fontSize: '0.88rem', color: '#607067', lineHeight: '1.5', margin: '0 0 28px 0' }}>
              Thank you for reaching out. We have received your training inquiry and will review your requirements to recommend a suitable training approach shortly.
            </p>
            
            <button
              onClick={() => setShowSuccess(false)}
              style={{
                background: '#0b8f55',
                color: '#fff',
                border: 'none',
                padding: '12px 32px',
                borderRadius: '999px',
                fontWeight: 800,
                fontSize: '0.94rem',
                cursor: 'pointer',
                boxShadow: '0 10px 24px rgba(11,143,85,0.22)',
                width: '100%',
                transition: 'all 0.2s'
              }}
              onMouseOver={(e) => { e.target.style.background = '#097344'; }}
              onMouseOut={(e) => { e.target.style.background = '#0b8f55'; }}
            >
              Back to Site
            </button>
          </div>
          
          <style dangerouslySetInnerHTML={{__html: `
            @keyframes fadeIn {
              from { opacity: 0; }
              to { opacity: 1; }
            }
            @keyframes pulseGreen {
              0% { box-shadow: 0 0 0 0 rgba(11, 143, 85, 0.4); }
              70% { box-shadow: 0 0 0 15px rgba(11, 143, 85, 0); }
              100% { box-shadow: 0 0 0 0 rgba(11, 143, 85, 0); }
            }
          `}} />
        </div>
      )}
    </main>
  );
}
